import { render, staticRenderFns } from "./TranslationProformTypePopup.vue?vue&type=template&id=5a0981d7"
import script from "./TranslationProformTypePopup.vue?vue&type=script&lang=js"
export * from "./TranslationProformTypePopup.vue?vue&type=script&lang=js"
import style0 from "./TranslationProformTypePopup.vue?vue&type=style&index=0&id=5a0981d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports